import {useRef} from 'react';
import Container from '@/container';
import {Row, Col} from '@/grid';
import {H2} from '@/typography';
import {withBgBrownRose50} from '@/hocs/withColors';
import {withMarginBottomXl} from '@/hocs/withSpacing';
import {SectionPadding} from '@/section';
import {BreakVisibleInDesktop} from '@/breaks';
import PictureWrapper from '@/ui/images-wrapper';
import ModalWrapper from '@/ui/modal-wrapper';
import {useTranslations} from 'next-intl';
import {Grid, VideoModalButton} from '@/content/features/shared';

const SectionBrownRose50 = withBgBrownRose50(SectionPadding);
const H2Margined = withMarginBottomXl(H2);

const imgPath = '/static/images/features/ats-video/';

const ATSVideoSection = () => {
  const t = useTranslations('features.atsVideo');
  const videoATSButtonRef = useRef<HTMLButtonElement | null>(null);
  const videoHRButtonRef = useRef<HTMLButtonElement | null>(null);

  const onVideoATSThumbClick = () => {
    videoATSButtonRef.current?.click();
  };

  const onVideoHRThumbClick = () => {
    videoHRButtonRef.current?.click();
  };

  return (
    <SectionBrownRose50>
      <Container>
        <Grid fluid>
          <Row center="xs">
            <Col xs={12}>
              <H2Margined>
                {t.rich('title', {
                  br: () => <BreakVisibleInDesktop />
                })}
              </H2Margined>
            </Col>
          </Row>
          <Row center="xs">
            <Col xs={12} md={11}>
              <Row center="xs" around="md">
                <Col xs={12} md={6}>
                  <ModalWrapper variant="modal-btn-wrapper">
                    <PictureWrapper
                      imgPath={imgPath}
                      imageUrl="workable-recruiting-video"
                      imageTypeFallback="jpg"
                      altImage={t('imageAlt')}
                      fetchpriority="high"
                      loading="eager"
                      width={480}
                      height={270}
                      onClick={onVideoATSThumbClick}
                    />
                    <VideoModalButton
                      ref={videoATSButtonRef}
                      openName="openList2"
                      videoId="u5ddzspbdu"
                      variant="image-green"
                      customAttributes={{
                        'data-gtm': 'generic-body-overview-video-ats-features'
                      }}
                      transcript={t('atsTranscript')}
                    />
                  </ModalWrapper>
                </Col>
                <Col xs={12} md={6}>
                  <ModalWrapper variant="modal-btn-wrapper">
                    <PictureWrapper
                      imgPath={imgPath}
                      imageUrl="workable-hr-video"
                      imageTypeFallback="jpg"
                      altImage={t('imageAlt')}
                      fetchpriority="high"
                      loading="eager"
                      width={480}
                      height={270}
                      onClick={onVideoHRThumbClick}
                    />
                    <VideoModalButton
                      ref={videoHRButtonRef}
                      openName="openList2"
                      videoId="3i8iuugqu3"
                      variant="image-green"
                      customAttributes={{
                        'data-gtm': 'generic-body-overview-video-hris-features'
                      }}
                      transcript={t('hrisTranscript')}
                    />
                  </ModalWrapper>
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
      </Container>
    </SectionBrownRose50>
  );
};

export default ATSVideoSection;
